// Description: Fourth Step of the campaign add page
// Updated: 26/09/2025
// Author: Simon Franklin

// React
import React from 'react'

// Material UI Components
import { Box, Button, FormControl, FormControlLabel, FormLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'

// Components and Functions for the project
import themeColors from '../../../components/ThemeColors/ThemeColors';
import DynamicInput from '../../../components/CreatingCampaign/DynamicInput';
import ListsModal from './ListsModal';

// Render The Component
const Step4 = ({ formState, error, setError, updateFieldValue, columnOptions }) => {
  const referenceOptions = [{ title: "Antes da data", id: 'before' }, { title: "Depois da data", id: 'after' }, { title: "No mesmo dia", id: 'sameDay' }];
  const operatorOptions = [{ title: "Igual", id: '==' }, { title: "Diferente", id: '!=' }, { title: "Nulo", id: 'is null' }, { title: "Não Nulo", id: 'is not null' }, { title: "Maior que", id: '>' }, { title: "Menor que", id: '<' }];
  const [openModal, setOpenModal] = React.useState(false);

  const activeColumns = [
    {
      field: 'title',
      headerName: 'Título',
      flex: 1,
    }
  ];

  const [field, setField] = React.useState("Em qual coluna estão as datas de vencimento?")
  const selectedDateColumn = columnOptions !== null && formState["Em qual coluna estão as datas de vencimento?"] !== "" ? columnOptions.filter((l) => l.id === formState["Em qual coluna estão as datas de vencimento?"])[0] : null;
  const selectedRuleColumn = columnOptions !== null && formState["Coluna da Regra"] !== "" ? columnOptions.filter((l) => l.id === formState["Coluna da Regra"])[0] : null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <FormControl sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
        <FormLabel style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Enviar em"] === true ? "red" : "#000", fontSize: "14px" }}>
          Enviar em
        </FormLabel>
        <RadioGroup value={formState["Enviar em"]} onChange={(e) => {
          updateFieldValue("Enviar em", e.target.value);
          if (error["Enviar em"] === true) {
            setError((prev) => ({
              ...prev,
              "Enviar em": false
            }));
          }
        }}>
          <FormControlLabel value={true} control={<Radio />} label="Somente dias úteis" />
          <FormControlLabel value={false} control={<Radio />} label="Todos os dias" />
        </RadioGroup>
      </FormControl>

      <p style={{ fontSize: "16px", fontWeight: 600 }}>Filtre sua lista</p>

      {
        formState["Tipo de campanha"] === "Recorrência" ? (
          <p style={{ fontSize: "16px", marginTop: "12px" }}>Você está no modo de campanha de recorrência, precisa selecionar pelo menos um filtro.</p>
        ) : null
      }

      <Box component="div" sx={{ display: "flex", gap: "40px", alignItems: "flex-end" }}>

        <FormControl sx={{ width: "auto", display: "flex", flexDirection: "column", gap: "12px" }}>
          <FormLabel style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Em qual coluna estão as datas de vencimento?"] === true ? "red" : "#000", fontSize: "14px" }}>
            Em qual coluna estão as datas de vencimento?
          </FormLabel>

          {
            formState["Em qual coluna estão as datas de vencimento?"] === "" ? (
              <p>
                -- Nenhuma Coluna Selecionada --
              </p>
            ) : (
              <p>
                -- {selectedDateColumn?.title} --
              </p>
            )
          }

          <Button onClick={() => (setField("Em qual coluna estão as datas de vencimento?"), setOpenModal(true))} variant="contained" sx={{ height: "39px", width: "267px", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "16px" }}>
            Selecionar Coluna
          </Button>
        </FormControl>

        <FormControl sx={{ width: "auto", display: "flex", flexDirection: "row", gap: "8px", height: "48px", alignItems: "flex-end" }}>
          <TextField
            name={"Dias"}
            variant="outlined"
            placeholder={"Dias"}
            value={formState["Dias"] === false ? "" : formState["Dias"]}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/\D+/g, '');
              updateFieldValue("Dias", onlyNumbers);

              if (error["Dias"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Dias": false
                }));
              }
            }}
            rows={4}
            fullWidth
            sx={{ '& .css-17m5yr0-MuiInputBase-root-MuiOutlinedInput-root': { backgroundColor: error["Dias"] === true ? themeColors.red01 : '#FFF', height: '100% !important' }, borderRadius: '6px', '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': { padding: '13px' }, maxWidth: "75px" }}
          />

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Dias"] === true ? "red" : "#000", fontSize: "16px", height: "100%" }}>
            Dias
          </div>
        </FormControl>

        <FormControl sx={{ width: "203px" }}>
          <Select
            name={"Referencia de Envio"}
            sx={{
              backgroundColor: error["Referencia de Envio"] === true ? themeColors.red01 : '#FFF',
              borderRadius: "6px",
              minWidth: "100%",
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "13px",
              },
            }}
            onChange={(e) => {
              const value = e.target.value;

              updateFieldValue("Referencia de Envio", value);

              if (error["Referencia de Envio"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Referencia de Envio": false
                }));
              }
            }}
            value={formState["Referencia de Envio"]}
          >
            <MenuItem style={{ color: themeColors.gray30 }} value={""} disabled>
              {"Referencia de Envio"}
            </MenuItem>
            {
              referenceOptions.map((option, index) => (
                <MenuItem key={index} value={option.id}>
                  {option.title}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>

      </Box>

      <p style={{ fontSize: "16px" }}>
        Somente clientes na sua listagem que atendem a seguinte condição receberão os disparos. Se você não utilizar o filtro todos os clientes serão selecionados.
      </p>

      <Box component="div" sx={{ display: "flex", gap: "40px", alignItems: "flex-end" }}>

        <FormControl sx={{ width: "auto", display: "flex", flexDirection: "column", gap: "12px" }}>
          <FormLabel style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Coluna da Regra"] === true ? "red" : "#000", fontSize: "14px" }}>
            Coluna da Regra
          </FormLabel>

          {
            formState["Coluna da Regra"] === "" ? (
              <p>
                -- Nenhuma Coluna Selecionada --
              </p>
            ) : (
              <p>
                -- {selectedRuleColumn?.title} --
              </p>
            )
          }

          <Button onClick={() => (setField("Coluna da Regra"), setOpenModal(true))} variant="contained" sx={{ height: "39px", width: "267px", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "16px" }}>
            Selecionar Coluna
          </Button>
        </FormControl>

        <Box sx={{ width: "203px" }}>
          <DynamicInput formState={formState} error={error} setError={setError} fullWidth type="select" options={operatorOptions} title={"Operador"} tooltip={""} updateFieldValue={updateFieldValue} />
        </Box>

        <Box sx={{ width: "203px" }}>
          <DynamicInput formState={formState} error={error} setError={setError} fullWidth type="text" options={operatorOptions} title={"Valor"} tooltip={""} updateFieldValue={updateFieldValue} />
        </Box>

      </Box>

      <ListsModal lists={columnOptions} open={openModal} updateFieldValue={updateFieldValue} onClose={() => setOpenModal(false)} title={"Selecione uma coluna"} field={field} activeColumns={activeColumns} setError={setError} />
    </div>
  )
}

export default Step4